export const GET_COURSE_TASK_INFO_SUCCESS = 'GET_COURSE_TASK_INFO_SUCCESS';
export const CHECK_AND_ADD_COURSE_TASK_SUCCESS = 'CHECK_AND_ADD_COURSE_TASK_SUCCESS';
export const UPDATE_BULLET_SUBJECT = 'UPDATE_BULLET_SUBJECT';
export const SET_SELECTED_BULLET_ID = 'SET_SELECTED_BULLET_ID';
export const SET_SELECTED_FILE_ID = 'SET_SELECTED_FILE_ID';
export const FILE_GENERATED_SUCCESS = 'FILE_GENERATED_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = 'Book Loading ...';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
